<!--
 * @Descripttion: 数据表组件
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-08-22 09:09:43
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-09-05 11:30:53
 -->
<!--
 * 本次升级相当于重构数据表
 * 数据表整合新增加、查看、编辑、删除
 * 取消之前版本的数据过滤、tag标签。改用对外抛出插槽形式
 * 尽量兼容响应式布局
 * 本次升级参考avue源码。
 -->
<template>
<div class="dataTables avue-crud">
    <el-card v-if="tableInfo" shadow="hover" body-style="padding:0px;">
        <!-- start::表头 -->
        <div v-if="tableInfo.header" slot="header" class="clearfix">
            <i class="fa fa-table" style="color:#409EFF" />
            <span class="tableInfoHeaderTitle"> {{tableInfo.header.title||'请初始化数据表标题或禁用数据表表头'}}</span>
            <!-- start::桌面端布局 -->
               <!-- 按钮数量小于等于2个的时候 -->
              <div class="inLine hidden-sm-and-down" v-if="tableInfo.header.options && tableInfo.header.options.length<=2">
                  <el-button size="mini" v-for="(item,index) in  tableInfo.header.options" @click="triggerEvent(item.clickEvent)" :key="index" class="tableInfoHeaderOptions" :type="item.type||'primary'" :icon="item.icon||'el-icon-question'">{{item.title||'无标题'}}</el-button>
              </div>
              <!-- 按钮数量大于2个的时候 -->
              <div v-else-if="tableInfo.header.options" class="inLine hidden-sm-and-down tableInfoHeaderOptions" >
                  <el-dropdown size="mini">
                      <el-button type="primary" size="mini">
                          更多
                          <i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item  v-for="(item,index) in  tableInfo.header.options" :key="index" divided>
                              <el-button size="mini" @click="triggerEvent(item.clickEvent)" :type="item.type||'primary'" :icon="item.icon||'el-icon-question'">{{item.title||'无标题'}}</el-button>
                          </el-dropdown-item>
                      </el-dropdown-menu>
                  </el-dropdown>
              </div>
            <div class="inLine hidden-sm-and-down" v-if="tableInfo.setting">
                <el-button icon="el-icon-delete" v-if="tableInfo.setting.allowDelete !==false " size="mini" @click="deleteRows()" type="danger" class="tableInfoHeaderOptions">删除</el-button>
                <el-button icon="el-icon-plus" v-if="tableInfo.setting.allowAdd !==false " size="mini" @click="addRow" type="primary" class="tableInfoHeaderOptions">新增</el-button>
            </div>
            <!-- end::桌面端布局 -->
            <!-- start::移动端布局 -->
            <div class="inLine hidden-md-and-up tableInfoHeaderOptions" v-if="tableInfo.header.options || tableInfo.setting.allowDelete !==false || tableInfo.setting.allowAdd !==false">
                <el-dropdown size="mini">
                    <el-button type="primary" size="mini">
                        菜单
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item  v-for="(item,index) in  tableInfo.header.options" :key="index" divided>
                            <el-button size="mini" @click="triggerEvent(item.clickEvent)" :type="item.type||'primary'" :icon="item.icon||'el-icon-question'">{{item.title||'无标题'}}</el-button>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="tableInfo.setting.allowAdd !==false " divided>
                            <el-button icon="el-icon-plus" size="mini" @click="addRow" type="primary">新增</el-button>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="tableInfo.setting.allowDelete !==false " divided>
                            <el-button icon="el-icon-delete" size="mini" @click="deleteRows()" type="danger">删除</el-button>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <!-- end::移动端布局 -->
        </div>
        <!-- end::表头 -->
        <!-- start::条件筛选容器 -->
        <el-col v-if="getConditionColumn().length !==0" :span="24" class="el-table_headtoolbar tableInfoCondition">
            <el-form :inline="true" :label-width="tableInfo.table.conditionSetting&&tableInfo.table.conditionSetting.labelWidth?tableInfo.table.conditionSetting.labelWidth:'120px'">
                <el-form-item v-for="(item,index)  in getConditionColumn()" :key="index" :label="item.label||'未设置名称'">
                    <!-- if::输入框情况 -->
                    <el-input size="medium" @change="resetCurrentPage" v-if="item.type === 'input' ||item.type === 'textarea'" v-model="tableInfo.table.reloadConditions[item.prop]" :placeholder="item.placeholder||'请输入内容'" ></el-input>
                    <!-- if::下拉选择框情况 -->
                    <el-select  size="medium" @change="resetCurrentPage" v-if="item.type === 'select'" v-model="tableInfo.table.reloadConditions[item.prop]" clearable :filterable="item.allowSearch?true:false" :placeholder="item.placeholder||'请选择'">
                        <div class="inLine" item.options>
                            <el-option v-for="(items,key) in item.options" :key="key" :label="items.name" :value="items.value"></el-option>
                        </div>
                    </el-select>
                    <!-- if::单个日期情况 -->
                    <el-date-picker size="medium" @change="resetCurrentPage" :value-format="item.valueFormat?item.valueFormat:''" v-if="item.type === 'date'" v-model="tableInfo.table.reloadConditions[item.prop]" type="date" placeholder="请选择日期"></el-date-picker>
                    <!-- if::日期区间情况 -->
                    <el-date-picker size="medium"  @change="resetCurrentPage" :style="tableInfo.condition.setting&&tableInfo.condition.setting.daterangeWidth?'width:'+tableInfo.condition.setting.daterangeWidth :'width:250px;'" :span="6" :value-format="item.valueFormat?item.valueFormat:''"
                        v-if="item.type === 'daterange'" v-model="tableInfo.table.reloadConditions[item.prop]" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>

                </el-form-item>
                <el-form-item >
                    <el-button-group >
                        <el-button size="medium" type="primary" @click="conditionsSearch">查询</el-button>
                        <el-button size="medium" type="info" @click="resetForm">重置</el-button>
                    </el-button-group>
                </el-form-item>

                <el-form-item>

                        <el-button size="medium" type="primary" @click="batchAudit">批量审核</el-button>

                </el-form-item>
                <el-form-item v-if="tableInfo.header.name !== 'class'">
                    <el-button size="medium" type="primary" @click="exportStatisticTable">导出统计表</el-button>
                    <el-button size="medium" type="primary" @click="exportApplicationTable">导出申请表</el-button>

                </el-form-item >
                <el-form-item v-else>
                     <el-button size="medium" type="primary" @click="backTo">返回上一步</el-button>
                </el-form-item>
            </el-form>
        </el-col>
        <!-- end::条件筛选容器 -->
        <!-- start::表单数据渲染区域 -->
      <el-table
        @row-click="clickRow"
        :header-cell-style="{'padding':'7px 0px'}"
        :cell-style="{'padding':'5px 0px'}"
        ref="table"
        v-if="tableInfo.table"
        @sort-change="sortChange"
        tooltip-effect="light"
        :row-style="tableInfo.table.rowStyle||{}"
        v-loading="tableInfo.table.loading||false"
        element-loading-text="玩命加载中"
        :stripe="tableInfo.table.stripe"
        :highlight-current-row="true"
        :data="tableInfo.table.tableData"
        :height="tableInfo.table.height"
        :max-height="tableInfo.table.maxHeight||tableInfo.table.height||500"
        border
        class="tableInfoTable"
        :row-key="getRowKeys"
      >
      <!-- 多选列 -->
      <el-table-column align="center"  fixed="left" width="50" type="selection" prop="rowid" :reserve-selection="true"></el-table-column>
        <!-- <el-table-column align="center" fixed="left" width="50" label="#" type="index" ></el-table-column> -->
        <!-- note::循环列 -->
        <div class="inLine" v-if="tableInfo.table.columns">
          <div class="inLine"  v-for="(item,index) in tableInfo.table.columns"  :key="index">
              <el-table-column
                      align="center"
                      show-overflow-tooltip
                      v-if="item.showInTable === false ?false:true && item.type === 'url'"
                      :prop="item.prop"
                      :label="item.label"
                      :fixed="item.fixed"
                      :sortable="item.sortable?true:false"
                      :width="item.width||''"
              >
              <template slot-scope="scope">
                  <!--<a :href="scope.row.path+'/?name=js'" class="tablelink">{{scope.row.processInstanceName}}</a>
                  -->
                  <router-link :to="{path: '/ResourceControl/workflow/form', query: { userId: scope.row.urlRow }}" class="tablelink">{{scope.row.processInstanceName}}</router-link>
                  <!--<slot v-if="item.slot"  :row="scope.row" :name="item.prop"></slot>
                  &lt;!&ndash; 如非插槽,这里还是保留数据过滤函数 &ndash;&gt;
                  <div v-else class="inLine">
                      <el-tag v-if="item&&item.tag" :type="typeof item.tagFilter === 'function'?item.tagFilter(scope.row[item.prop]).type:''">
                          {{ typeof item.tagFilter === 'function'?item.tagFilter(scope.row[item.prop]).data:scope.row[item.prop] }}
                      </el-tag>
                      <span v-else>
                          {{typeof item.dataFilter === 'function'?item.dataFilter(scope.row[item.prop]):scope.row[item.prop]}}
                      </span>
                  </div>-->
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              v-if="item.showInTable === false ?false:true && item.type !== 'url'"
              :prop="item.prop"
              :label="item.label"
              :fixed="item.fixed"
              :sortable="item.sortable?true:false"
              :width="item.width||''"
            >

            </el-table-column>
          </div>
        </div>
        <!-- note::循环操作 -->
        <el-table-column
          align="center"
          v-if="tableInfo.table.operation&&(tableInfo.table.operation.operations.length!=0 || tableInfo.table.operation.slot||tableInfo.setting.allowView !==false ||tableInfo.setting.allowEdit !==false ||tableInfo.setting.allowDelete !==false )"
          fixed="right"
          :width="tableInfo.table.operation&&tableInfo.table.operation.width?tableInfo.table.operation.width:''"
          label="操作"
        >
          <template slot-scope="scope">
              <!-- 如果操作列需要插槽展示,这里变对外抛出插槽 -->
              <slot v-if="tableInfo.table.operation.slot" name="operation" :row="scope.row"></slot>
              <!-- 内部遍历按钮 -->
              <div v-else class="inLine">
                <el-button v-if="tableInfo.setting.allowView !==false " type="text" @click="viewRow(scope.row)">
                    <span >查看</span>
                </el-button>
                <el-button v-if="tableInfo.setting.allowEdit !==false " type="text" @click="editRow(scope.row)">
                    <span style="color:#9f8bea">编辑</span>
                </el-button>
                <el-button v-if="tableInfo.setting.allowDelete !==false " type="text" @click="deleteRows(scope.row)">
                    <span style="color:#e78ab0">删除</span>
                </el-button>
                <!-- 开始循环自定义的操作 -->
                 <el-button
                    v-for="(item,index) in tableInfo.table.operation.operations"
                    :key="index"
                    :type="'text'"
                    @click="triggerEvent(item.clickEvent,scope.$index, scope.row)"
                    >
                    <span :style="{color:item.color}">{{item.title}}</span>
                </el-button>
              </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- end::表单数据渲染区域 -->
            <!-- start::页脚渲染区域 -->
      <nav
        v-if="tableInfo.table && tableInfo.table.paging"
        style="text-align: center;margin:10px 0"
      >
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="tableInfo.table.paging.currentPage||1"
          :page-sizes="tableInfo.table.paging.pageSizes||[20, 30, 50, 100]"
          :page-size="tableInfo.table.paging.pageSize||20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableInfo.table.paging.total||0"
        ></el-pagination>
      </nav>
      <!-- end::页脚渲染区域 -->
    </el-card>

    <batch-form-dialog :auditFormDialog="batchAuditFormDialog">
    </batch-form-dialog>
    <!-- 以下是新增,编辑,查看 显示框 -->
    <!-- 新增加 -->
    <formDialog :formDialogInfo="conf.formDialogInfoAddRow"
    @addRowInternalFunction="addRowInternalFunction">
      <template  slot="table">
        <slot name="tableForAdd"></slot>
      </template>
    </formDialog>
    <!-- 查看 -->
    <formDialog :formDialogInfo="conf.formDialogInfoViewRow">
      <template  slot="table">
        <slot name="tableForView"></slot>
      </template>
    </formDialog>
    <!-- 编辑 -->
    <formDialog :formDialogInfo="conf.formDialogInfoEditRow"
    @editRowInternalFunction="editRowInternalFunction">
      <template  slot="table">
        <slot name="tableForEdit"></slot>
      </template>
    </formDialog>
</div>
</template>

<script>
import { deepClone } from '@/framework/util/util.js'

import batchFormDialog from './batchAuditFormDialog'
// import conf from './conf'd
// import create from 'core/create'
export default {
  data() {
    const formDialogInfoAddRow = {
      header: {
        title: '新增',
        dialogVisible: false,
        width: '50%',
        marginTop: '5vh'
      },
      data: {},
      from: {
        labelWidth: 'auto',
        fromItems: []
      },
      formButton: [{
        clickEvent: 'addRowInternalFunction',
        buttonName: '保存',
        type: 'primary',
        loading: false
      }]
    }

    const formDialogInfoViewRow = {
      header: {
        title: '查看',
        dialogVisible: false,
        width: '50%',
        marginTop: '5vh'
      },
      data: {},
      from: {
        labelWidth: 'auto',
        fromItems: []
      },
      formButton: []
    }

    const formDialogInfoEditRow = {
      header: {
        title: '编辑',
        dialogVisible: false,
        width: '50%',
        marginTop: '5vh'
      },
      data: {},
      from: {
        labelWidth: 'auto',
        fromItems: []
      },
      formButton: [{
        clickEvent: 'editRowInternalFunction',
        buttonName: '保存',
        type: 'primary',
        loading: false
      }]
    }
    return {
      batchAuditFormDialog: {
          dialogVisible: false,
          width: '360px'
      },
      conf: {
        formDialogInfoAddRow,
        formDialogInfoViewRow,
        formDialogInfoEditRow
      }
    }
  },
  props: ['tableInfo'],

  components: { batchFormDialog },

  methods: {
      getAuth(){//权限验证

      },
      batchAudit(){
          //this.getAuth()
          if(this.tableInfo.table.paging.total === 0){
              this.$message.info('当前无需要审批的流程')
              return
          }
          let selectedRows = this.getSelectedRows();
          if(selectedRows.length === 0){
              this.$message.info('请先选择记录')
              return
          }else if(selectedRows.length > 1){
              let firstRow = selectedRows[0]
              for(let i = 1; i < selectedRows.length; i++){
                 if(firstRow.processInstanceStartUserId !== selectedRows[i].processInstanceStartUserId){
                     this.$message.info("请选择相同名称的参评记录")
                     return
                 }

              }
          }
          //this.doTimeAudit()//时间校验

          console.log(selectedRows)
          this.batchAuditFormDialog.dialogVisible = true
          if(this.batchAuditFormDialog.selectedValue){
              console.log(this.batchAuditFormDialog.selectedValue)
          }
          this.doAudit(selectedRows)
      },
      doTimeAudit(){

      },
      doAudit(selectedRows){
          this.batchAuditFormDialog.dialogVisible = true
      },
      exportStatisticTable(){
          //this.$message.info('hello statistic')
          console.log('hellow')
          if(!this.tableInfo.table.reloadConditions['processInstanceStartId']){
              this.$message.info('请先在查询下拉框参评名称选择需要导出的参评名称')
              return
          }
          console.log(this.tableInfo.table.reloadConditions['processInstanceStartId'])
      },
      exportApplicationTable(){
          if(!this.tableInfo.table.reloadConditions['processInstanceStartId']){
              this.$message.info('请先在查询下拉框参评名称选择需要导出的参评名称')
              return
          }
      },
      backTo(){

      },
      getRowKeys (row) {
          return row.id; // id为列表数据的唯一标识
      },
    /** 删除函数 */
    deleteRows: function(row, index) {
      var deleteList = []
      /** 判断是多行删除还是单行删除 */
      if (row) {
        deleteList.push(row)
      } else {
        deleteList = this.getSelectedRows()
        if (deleteList.length === 0) {
          this.$message({ message: '请选中一条记录再操作哟。', type: 'warning' })
          return false
        }
      }
      /** 开始执行删除    **  先询问 */
      this.$confirm('删除后不可恢复, 是否继续?', '提示', { cancelButtonText: '取消', confirmButtonText: '确定', type: 'warning' }).then(() => {
        this.triggerEvent(this.tableInfo.setting.deleteFunctionName || 'deleteRows', deleteList)
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消删除' })
      })
    },
    /** 新增函数 */
    addRow: function() {
      var callback = () => {
        this.conf.formDialogInfoAddRow.header.dialogVisible = true
        this.tableInfo.table.rowCache = this.conf.formDialogInfoAddRow.data = this.tableInfo.table.addDefultValue || {}
        if (this.conf.formDialogInfoAddRow.from.fromItems.length !== 0) {
          return
        }
        let columns = deepClone(this.tableInfo.table.columns)
        columns.forEach((item, index) => {
        /** 是否显示 */
          if (item.view && item.view.length === 3 ? item.view[0] : true) {
            item.disabled = item.disabled && item.disabled.length === 3 ? item.disabled[0] : false
            this.conf.formDialogInfoAddRow.from.fromItems.push(item)
          }
        })
      }
      if (this.tableInfo.setting.beforeAddFunctionName) {
        this.triggerEvent(this.tableInfo.setting.beforeAddFunctionName, null, 'ADD', callback)
      } else {
        callback()
      }
    },
    /** 新增的保存按钮触发函数 触发到根组件*/
    addRowInternalFunction: function(rowData) {
      /** 保存按钮转圈 */
      this.conf.formDialogInfoAddRow.formButton[0].loading = true
      this.triggerEvent(this.tableInfo.setting.addFunctionName || 'addRow', rowData, () => {
        this.conf.formDialogInfoAddRow.header.dialogVisible = false
        this.conf.formDialogInfoAddRow.formButton[0].loading = false
      }, () => {
        this.conf.formDialogInfoAddRow.formButton[0].loading = false
      }, 'ADD')
    },
    /** 编辑某行 */
    editRow: function(row) {
      var callback = () => {
        this.conf.formDialogInfoEditRow.header.dialogVisible = true
        this.tableInfo.table.rowCache = this.conf.formDialogInfoEditRow.data = deepClone(row)
        if (this.conf.formDialogInfoEditRow.from.fromItems.length !== 0) {
          return
        }
        let columns = deepClone(this.tableInfo.table.columns)
        columns.forEach((item, index) => {
        /** 是否显示 */
          if (item.view && item.view.length === 3 ? item.view[2] : true) {
            item.disabled = item.disabled && item.disabled.length === 3 ? item.disabled[2] : false
            this.conf.formDialogInfoEditRow.from.fromItems.push(item)
          }
        })
      }
      if (this.tableInfo.setting.beforeEditFunctionName) {
        this.triggerEvent(this.tableInfo.setting.beforeEditFunctionName, row, 'EDIT', callback)
      } else {
        callback()
      }
    },
    /** 编辑的保存按钮触发函数 触发到根组件*/
    editRowInternalFunction: function(rowData) {
      this.conf.formDialogInfoEditRow.formButton[0].loading = true
      this.triggerEvent(this.tableInfo.setting.editFunctionName || 'editRow', rowData, () => {
        this.conf.formDialogInfoEditRow.header.dialogVisible = false
        this.conf.formDialogInfoEditRow.formButton[0].loading = false
      }, () => {
        this.conf.formDialogInfoEditRow.formButton[0].loading = false
      }, 'EDIT')
    },
    /** 查看某一行数据 */
    viewRow: function(row) {
      var callback = () => {
        this.conf.formDialogInfoViewRow.header.dialogVisible = true
        this.tableInfo.table.rowCache = this.conf.formDialogInfoViewRow.data = row
        if (this.conf.formDialogInfoViewRow.from.fromItems.length !== 0) {
          return
        }
        let columns = deepClone(this.tableInfo.table.columns)
        columns.forEach((item, index) => {
        /** 是否显示 */
          if (item.view && item.view.length === 3 ? item.view[1] : true) {
            item.disabled = item.disabled && item.disabled.length === 3 ? item.disabled[1] : true
            this.conf.formDialogInfoViewRow.from.fromItems.push(item)
          }
        })
      }
      if (this.tableInfo.setting.beforeViewFunctionName) {
        this.triggerEvent(this.tableInfo.setting.beforeViewFunctionName, row, 'VIEW', callback)
      } else {
        callback()
      }
    },

    /** 父组件事件触发器  默认4参数  x为事件 */
    triggerEvent: function(x, y, z, a, b) {
      this.$emit(x, y, z, a, b)
    },
    /** 重置表格筛选函数 */
    resetForm: function() {
      /** 清除表格条件 */
      this.tableInfo.table.reloadConditions = {}
      /** 修改当前页码*/
      this.resetCurrentPage()
    },
    /** 表格条件查询函数 */
    conditionsSearch: function() {
      this.reload()
    },
    /** 触发父组件重载条件 */
    reload: function() {
      this.$emit(this.tableInfo.table.reload, this.getReloadConditions())
    },
    /** 排序改变事件 */
    sortChange: function({ column, prop, order }) {
      this.tableInfo.table['serverSort'] = {}

      /** 当排序发生改变时,检测是否为服务器排序,如果为服务器排序。则添加服务器排序设置。 */
      /** 循环数据列配置，查询是否开启服务器排序 */
      for (
        var index = 0;
        index < this.tableInfo.table.columns.length;
        index++
      ) {
        if (prop === this.tableInfo.table.columns[index].prop) {
          break
        }
      }
      if (this.tableInfo.table.columns[index].serverSort) {
        this.tableInfo.table['serverSort']['sidx'] = prop

        this.tableInfo.table['serverSort']['sord'] = order
      }
      /** 重载数据表 */
      this.reload()
    },
    /**  页大小改变函数 */
    handleSizeChange: function(val) {
      this.tableInfo.table.paging['pageSize'] = val
      this.reload()
    },
    /** 页改变事件 */
    handleCurrentChange: function(val) {
      this.tableInfo.table.paging['currentPage'] = val
      this.reload()
    },
    /** 从表格配置中筛选条件选项 */
    getConditionColumn() {
      let ConditionColumn = []
      this.tableInfo.table.columns.forEach(element => {
        if (element.isSearchCondition) {
          ConditionColumn.push(element)
        }
      })
      return ConditionColumn
    },
    /** 重置当前页 */
    resetCurrentPage: function() {
      if (
        this.tableInfo.table.paging &&
        this.tableInfo.table.paging.currentPage
      ) {
        this.tableInfo.table.paging.currentPage = 1
      }
    },
    /** 获取选中行 */
    getSelectedRows: function() {
      return this.$refs.table.selection || []
    },
    /** 单击行 */
    clickRow(row, a, b) {
      this.$emit("getSelected",row)
      if (a.label !== '操作') {
        this.$refs.table.toggleRowSelection(row)
      }
    },
    /** 获取表格重载条件 */
    getReloadConditions: function() {
      let retult = {}
      /** 读取条件集合 */
      for (let conditionItem in this.tableInfo.table.reloadConditions) {
        if (this.tableInfo.table.reloadConditions[conditionItem] || this.tableInfo.table.reloadConditions[conditionItem] === 0) {
          retult[conditionItem] = this.tableInfo.table.reloadConditions[conditionItem]
        }
      }
      /** 在存在 paging 且 paging 合法 的情况下 获取 paging 条件集合 */
      if (
        this.tableInfo.table.paging &&
        this.tableInfo.table.paging.currentPage > 0 &&
        this.tableInfo.table.paging.pageSize > 0 &&
        this.tableInfo.table.paging.pageSize <= 500
      ) {
        retult['pageNum'] = this.tableInfo.table.paging.currentPage
        retult['pageSize'] = this.tableInfo.table.paging.pageSize
      }
      /** 获取tableInfo 中 serverSort 字段。 */
      if (
        this.tableInfo.table['serverSort'] &&
        this.tableInfo.table['serverSort'].sidx &&
        this.tableInfo.table['serverSort'].sord
      ) {
        retult['sidx'] = this.tableInfo.table['serverSort'].sidx
        retult['sord'] = this.tableInfo.table['serverSort'].sord
      }
      return retult
    },
    /** 为某列设置配置参数 */
    setColumnSeting: function(columnName, setingName, steingValue) {
      for (
        var index = 0;
        index < this.tableInfo.table.columns.length;
        index++
      ) {
        if (columnName === this.tableInfo.table.columns[index].prop) {
          break
        }
      }

      // this.tableInfo.table.columns[index][setingName] = steingValue
      this.$set(this.tableInfo.table.columns[index], setingName, steingValue)
    },
    /** 获取参数 */
    getColumnSeting: function(columnName, setingName) {
      for (
        var index = 0;
        index < this.tableInfo.table.columns.length;
        index++
      ) {
        if (columnName === this.tableInfo.table.columns[index].prop) {
          break
        }
      }
      return this.tableInfo.table.columns[index][setingName]
    }
  }
}
</script>
<style lang='scss' scoped>
    .tablelink{
        color: blue;
    }
.tableInfoHeaderOptions {
    float: right;
    margin-right: 15px;
}

.tableInfoHeaderTitle {
    text-indent: 2px;
    color: #409eff;
}

.tableInfoCondition {
    padding-bottom: 0px;
    margin-top: 5px;
}

.tableInfoTable {
    font-size: 14px;
    width: 100%;
    padding-top: 0;
}

.inLine {
    display: inline;
}
</style>
